const handleApiErrors = (message, error) => {
  console.log('*** ERROR IN API CALL ', message, error)
}

export {
  handleApiErrors
}
